<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-part-number-changes-additional-input class="additional-input"
                                          (deleteClick)="delete()"
                                          [additionalIndex]="additionalIndex"
                                          [additionalTypeCypressTag]="CYPRESS_TAG"
                                          [baseClass]="styleClass"
                                          [isDetailMode]="isDetailMode"
                                          [isInViewMode]="isInViewMode"
                                          [isDetailSolvedTrial]="isDetailSolvedTrial"
                                          [isSolvedStatus]="isSolvedStatus"
                                          [labelAdditional]="LABEL_ADDITIONAL"
                                          [labelNew]="LABEL_NEW"
                                          [isSolutionAccepted]="isSolutionAccepted">
    <app-input-text #spoNumberInput
                    (inputStateChange)="manageSpoNumberMessages($event)"
                    (inputValueChange)="spoNumberChange($event)"
                    [baseCypressTag]="baseCypressTag"
                    [initialValue]="spoNumberInitialValue"
                    [showViewMode]="isInViewMode"
                    [validators]="validators.spoNumber"
                    [messages]="spoNumberInputMessages"
                    [isToUpperCaseInputTextValue]="true"
                    label="{{spoNumberLabel}}"
                    maxLength="10"
                    placeholder="e.g. S000000000"></app-input-text>
</app-part-number-changes-additional-input>
